import React from 'react'
// Componentes UI
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
// Componentes
import Permiso from '../../components/wrappers/permiso';
import ContactoTI from "../../components/contacto-ti/contacto-ti";
import ModuleLayout from '../../layouts/layout-modulo.js';
// Estilos y Assets
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import "./mecanica.css";

function MecanicaTK() {
  const navigate = useNavigate();

  const nuevoRegistro = () => { navigate('revisiones/nuevo')};
  const seguimientoInformes = () => { navigate('seguimiento-informes'); }
  const verInformes = () => { navigate('ver/revisiones-vehiculares'); };
  
  return (
    <ModuleLayout titulo="Taller Mecánico" logo={logo} onVolver={() => navigate('/app')}>
      <section className="mod-content">
        <div className="mod-banner">
          <p className="m-0">
            Aquí podrá gestionar todas las operaciones relacionadas con el taller mecánico, 
            como la creación de registro de servicio de vehiculo, y el historial de registros hasta la fehca.
          </p>
        </div>

        <div className='container-cards'>
          <Permiso modulo="Taller Mecánico" permiso="MEC_CREAR_INFORME">
            <div className="mod-card">
              <Card
                title="Recepción Inicial"
                className="card-dash"
                footer={ 
                  <Button 
                    className="btn btn-primary" 
                    label="Registrar nuevo"
                    icon="pi pi-plus" 
                    onClick={nuevoRegistro}
                  />
                }
              ><p>
                  Esta funcionalidad permite <b>generar un informe descargable </b> 
                  del servicio realizado a un vehículo en el taller, 
                  incluyendo detalles como el tipo de servicio, fecha, 
                  kilometraje, entre otros.
                </p>
              </Card>
            </div>
          </Permiso>

          <Permiso modulo="Taller Mecánico" permiso="MEC_VER_INFORMES">
            <div className="mod-card">
              <Card
                title="Seguimiento Informes"
                className="card-dash"
                footer={ 
                  <Button className="btn btn-outline-primary" label="Consultar Informes"
                  icon="pi pi-table" onClick={seguimientoInformes} />
                }
              >
                <p>
                  Esta funcionalidad permite acceder a una tabla <b>resumen con todos 
                  los informes generados</b> de revisiones de vehículos. 
                  Podrá consultar y descargar la información de cada revisión. 
                </p>
              </Card>
            </div>
          </Permiso>

          <Permiso modulo="Taller Mecánico" permiso="MEC_VER_INFORMES">
            <div className="mod-card">
              <Card
                title="Informes Anteriores"
                className="card-dash"
                footer={ 
                  <Button className="btn btn-outline-primary" label="Consultar Informes"
                  icon="pi pi-table" onClick={verInformes} />
                }
              >
                <p>
                  Esta funcionalidad permite acceder a una tabla <b>resumen con todos 
                  los informes generados</b> de revisiones de vehículos. 
                  Podrá consultar y descargar la información de cada revisión. 
                </p>
              </Card>
            </div>
          </Permiso>
        </div>

        <ContactoTI />
      </section>
    </ModuleLayout>
  );
}

export default MecanicaTK